import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const RAZORPAY_SCRIPT = 'https://checkout.razorpay.com/v1/checkout.js';

export const loadRazorpay = () => new Promise((resolve, reject) => {
  if (window.Razorpay) return resolve();
  const s = document.createElement('script');
  s.src = RAZORPAY_SCRIPT; s.async = true;
  s.onload = () => resolve();
  s.onerror = () => reject(new Error('Razorpay SDK failed to load'));
  document.body.appendChild(s);
});

// Opens Checkout for a tenant-invoice order ({invoice_id, razorpay}) and verifies on success.
export const payTenantInvoice = async (data, { description, user, onDone, onError, onDismiss }) => {
  await loadRazorpay();
  const rz = data.razorpay;
  const rzp = new window.Razorpay({
    key: rz.key_id, amount: rz.amount, currency: rz.currency, order_id: rz.order_id,
    name: 'AUDINEXA — Clinic OS', description,
    prefill: { name: user?.name || '', email: user?.email || '' },
    modal: { ondismiss: () => onDismiss && onDismiss() },
    handler: async (resp) => {
      try {
        await axios.post(`${API}/billing/tenant-invoices/${data.invoice_id}/razorpay/verify`, resp);
        onDone && onDone();
      } catch (e) {
        onError && onError('Verification failed: ' + (e?.response?.data?.detail || e.message));
      }
    },
  });
  rzp.on('payment.failed', (r) => onError && onError(`Payment failed: ${r?.error?.description || ''}`));
  rzp.open();
};
